
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiScreenSharing as ObiScreenSharingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-screen-sharing.js';
 
 
 

 
 export const ObiScreenSharing = createComponent({
   react: React,
   tagName: 'obi-screen-sharing',
   elementClass: ObiScreenSharingElement,
   events: {
     
   }
  });
 
 